import { createContext } from 'react'

import { AureusChunkItem } from '@utils/aureus/queries/chunks'

export type DeboostOnClickFn = ({
  aureusOfferId,
  articleId,
}: {
  aureusOfferId?: AureusChunkItem['aureusOfferId']
  articleId?: AureusChunkItem['articleID']
}) => void

export type AureusDeboostContextType = {
  deboostOnClick: DeboostOnClickFn
}

const AureusDeboostContext = createContext<
  AureusDeboostContextType | undefined
>(undefined)

export default AureusDeboostContext
